import { _ } from "../../../../core/polyglot/polyglot.js";
import dialog from "../../../../core/widgets/dialog.js";
import selection from "../../../../models/accounting/document/selection.js";
import TreeWidget from "../../../../core/widgets/tree/TreeWidget/TreeWidget.js";

/**
 * I am the widget used to move entries.
 * I display a popup with the file tree (stubbed) to let the
 * user choose the pasting target.
 *
 * I should only be used through the proper command.
 */

/**
 * Todo: Add JSDoc comment
 */
export default function moveEntriesDialog(command, my) {
	my ||= {};

	const tree = new TreeWidget({
		data: [command.getRoot()],
		getChildren: function (entry) {
			if (selection.includesEntry(entry)) {
				return [];
			}
			return entry.children();
		},
		getLabel: function (entry) {
			return function (html) {
				let icon;
				if (entry.isFile()) {
					icon = "tree-icon fa-file";
				} else if (entry.isRoot()) {
					icon = "tree-icon fa-home";
				} else {
					icon = "tree-icon fa-folder-open";
				}

				html.i({
					klass: ["fa", icon],
				});

				html.render(entry.getLabel());
			};
		},
		getId: function (entry) {
			return entry.id();
		},
		canBeSelected: canSelectNode,
	});

	const that = dialog({ cssClass: "resizable-modal-content" }, my);

	my.title = _("Move items");

	my.content = function (html) {
		html.render(tree);
		tree.scrollTo(command.getEntry());
	};

	my.footer = function (html) {
		const moveButton = html
			.button(
				{
					"data-test": "confirm-move",
					klass: "btn btn-primary",
				},
				_("Move"),
			)
			.click(moveEntry);

		html.button({ klass: "btn" }, _("Cancel")).click(that.hide);

		moveButton.asJQuery().attr("disabled", "disabled");

		tree.onSelectionChange.register((entry) => {
			if (entry) {
				moveButton.asJQuery().removeAttr("disabled");
			} else {
				moveButton.asJQuery().attr("disabled", "disabled");
			}
		});
	};

	function canSelectNode(entry) {
		return !selection.includesId(entry.id()) && entry.isFolder();
	}

	function moveEntry() {
		const destination = tree.selectedNode();
		that.hide();
		command.setDestination(destination);
		command.doPerform();
	}

	return that;
}
